document.addEventListener('DOMContentLoaded', () => {
    const header = document.getElementById('site-header');
    if (!header) return;

    const solidify = () => header.classList.add('site-header--solid');
    const unsolidify = () => {
        if (window.scrollY === 0 && !header.matches(':hover')) {
            header.classList.remove('site-header--solid');
        }
    };

    window.addEventListener('scroll', () => {
        if (window.scrollY > 0) solidify();
        else unsolidify();
    }, { passive: true });

    header.addEventListener('mouseenter', solidify);
    header.addEventListener('mouseleave', unsolidify);
});
